<template>
  <div class="person">
    <FormItem :prop="formKey + '.name'" label=" 姓名(中文)" :rules="$units.formRule.required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'name')">{{ formData.name }}</span>
      <Input v-else type="text" v-model="formData.name" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.name" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowname" @click="openEye(formData, 'name')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.pyName'" label="姓名(拼音)">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'pyName')">{{ formData.pyName }}</span>
      <Input v-else type="text" v-model="formData.pyName" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.pyName" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpyName" @click="openEye(formData, 'pyName')"></i>
      </a>
    </FormItem>
    <!-- 受保人显示 -->
    <FormItem v-if="formKey == 'insurce'" label="证件类型">
      <lzDicTxt :dicCode="formData.cardType" dicType="ID_CARD_TYPE" />
    </FormItem>
    <FormItem :prop="formKey + '.idCard'" :label="formKey == 'insurce' ? '证件号码' : '身份证号码'" :rules="$units.formRule.required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'idCard')">{{ formData.idCard }}</span>
      <Input v-else type="text" v-model="formData.idCard" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.idCard" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowidCard" @click="openEye(formData, 'idCard')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.mobile'" label="联系电话">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'mobile')">{{ formData.mobile }}</span>
      <Input v-else type="text" v-model="formData.mobile" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.mobile" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowmobile" @click="openEye(formData, 'mobile')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.birthday'" label="出生日期">
      <span v-if="disabled">{{ formData.birthday | filterTime('YYYY-MM-DD') }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.birthday"></DatePicker>
    </FormItem>

    <FormItem :prop="formKey + '.sex'" label="性别">
      <span v-if="disabled">{{ formData.sex | filterSex }}</span>
      <Select v-else v-model="formData.sex" filterable transfer clearable>
        <Option v-for="(txt, value) in $dic.sex" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import validUserName from '@/components/commons/validUserName';
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  mixins: [common],
  components: {
    lzDicTxt,
    validUserName
  },
  props: ['companyList', 'productList', 'formData', 'formKey', 'disabled'],
  data() {
    return {
      title: ''
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {
    // 解密
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      console.log(this.formKey);
      let index = null;
      let formKey = this.formKey;
      if (this.formKey.indexOf('[') != -1) {
        formKey = this.formKey.split('[')[0];
        index = this.formKey.split('[')[1].split(']')[0];
      }
      let customerType = {
        //       用户类型 1-投保人 2-受保人 3-受益人 4-保单第二持有人
        'holder': '1',
        'insurce': '2',
        'beneficaryList': '3'
      };
      if (!row['eyeShow' + code]) {
        const map = {
          idCard: 1,
          mobile: 2,
          pyName: 13,
          name: 12
        };
        this.descrypt(
          {
            index,
            customerType: customerType[formKey],
            query: row.id,
            operationFunction: 3,
            operationType: map[code]
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
